import { Button, Card, Checkbox, Col, Form, Icon, Input, InputNumber, Mentions, Popconfirm, Row, Select, Spin, Tooltip } from "antd";
import React from "react";
import { sanitizeFieldName } from "../../util/methods";
import Cron from "react-cron-generator";
import "react-cron-generator/dist/cron-builder.css";
import "./event.css";
import { stringify } from "query-string";
import { OptionProps } from "antd/lib/mentions";
import axios from "../../util/Api";

const { Option, getMentions } = Mentions;
const { TextArea } = Input;

let id = 1;
let alertAssigneeId = 1;
const ALL_OPTION = "ALL";

// Empty location/sub location means "all", same as the explicit ALL option.
const toAssigneeScopeValue = value => (!value || value === ALL_OPTION ? ALL_OPTION : value.toString());
const assigneeScopeDimensionOverlaps = (a, b) => a === ALL_OPTION || b === ALL_OPTION || a === b;
const assigneeScopesOverlap = (a, b) =>
  assigneeScopeDimensionOverlaps(a.location, b.location) &&
  assigneeScopeDimensionOverlaps(a.subLocation, b.subLocation);

class Create extends React.Component {
  constructor() {
    super();
    this.state = {
      isActive: false,
      notificationType: [],
      documentData: [],
      slackDocumentData: [],
      value: "",
      eventType: "",
      eventStatus: false,
      moduleName: '',
      locations: [],
      subLocations: [],
      // id: 1,
    };
  }

  getInitialAlertAssigneeKeys = (alertAssignee) => {
    const count = alertAssignee && alertAssignee.length > 0 ? alertAssignee.length : 1;
    return [...Array(count)].map((_, index) => `ak_${index}`);
  };

  async componentDidMount() {
    const { match, fetch } = this.props;
    try {
      const [locations, subLocations] = await Promise.all([
        axios.get(`/location`),
        axios.get(`/client`)
      ]);
      this.setState({
        locations: locations && locations.data && locations.data.data ? locations.data.data : [],
        subLocations: subLocations && subLocations.data && subLocations.data.data ? subLocations.data.data : []
      });
    } catch (error) {
      this.setState({
        locations: [],
        subLocations: []
      });
    }
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    if (this.props.title === "EDIT") {
      this.setState({
        notificationType: this.props.data.notificationType || [],
        eventType: this.props.data.eventType || "",
        value: this.props.scheduleOptions || "",
        isActive: this.props.data.isActive || false,
        moduleName: this.props.data.module || "",
        // id: this.props.data.reminderOptions && this.props.data.reminderOptions.length || 1,
      });
      id = this.props.data.reminderOptions ? this.props.data.reminderOptions.length : 1;
      alertAssigneeId = this.props.data.alertAssignee && this.props.data.alertAssignee.length > 0 ? this.props.data.alertAssignee.length : 1;
      // console.log(id, this.props.data.reminderOptions);
    }
    if (this.props.title === "CREATE") {
      this.setState({
        value: "* * * * * *",
        isActive: this.props.data.isActive || false
      });
    }
  }

  getStatus = (event) => {
    if (event && event.eventCode && (event.eventType === 'Schedule' || event.eventType === 'Reminder')) {
      this.props.getStatus(event.eventCode);
    }
  };

  // componentDidUpdate() {
  //   console.log(this.props.data);
  //   if(this.props.title === "EDIT") {
  //     // this.props.status(this.props.data.eventCode);
  //   }
  // }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.data &&
      stringify(this.props.data) !== stringify(nextProps.data)
    ) {
      if (nextProps.data && nextProps.data.module) {
        this.props.fetchFilter(nextProps.data.module);
        if (this.props.title === "EDIT") {
          this.setState({
            notificationType: nextProps.data.notificationType || [],
            eventType: nextProps.data.eventType || "",
            value: nextProps.data.scheduleOptions || "",
            isActive: nextProps.data.isActive || false,
            moduleName: nextProps.data.module || "",
            //id: this.props.data.reminderOptions && this.props.data.reminderOptions.length || 1,
          });
          // const {form} = this.props;
          // const keys = form.getFieldValue("con_keys");
          // console.log(id);
          // // id = 1; //this.state.id;
          // for (let i = 0; i < (this.props.data.reminderOptions ? this.props.data.reminderOptions.length : 0); i++) {
          //   id += i;
          //   form.setFieldsValue({
          //     con_keys: keys.concat(id),
          //   });
          // }
          // console.log(nextProps.data['reminderOptions']);
          id = nextProps.data['reminderOptions'] ? nextProps.data['reminderOptions'].length : 1;
          alertAssigneeId = nextProps.data['alertAssignee'] && nextProps.data['alertAssignee'].length > 0 ? nextProps.data['alertAssignee'].length : 1;
          const alertAssigneeKeys = this.getInitialAlertAssigneeKeys(nextProps.data['alertAssignee']);
          const alertAssigneeFieldValues = { alert_assignee_keys: alertAssigneeKeys };
          (nextProps.data['alertAssignee'] || []).forEach((assignee, index) => {
            const key = alertAssigneeKeys[index];
            if (!key) {
              return;
            }
            const locationId = assignee && assignee.location && assignee.location._id
              ? assignee.location._id
              : assignee && assignee.location;
            const subLocationId = assignee && assignee.subLocation && assignee.subLocation._id
              ? assignee.subLocation._id
              : assignee && assignee.subLocation;
            const userId = assignee && assignee.user && assignee.user._id
              ? assignee.user._id
              : assignee && assignee.user;
            alertAssigneeFieldValues[`alertAssigneeLocation_${key}`] = assignee && assignee.allLocation ? ALL_OPTION : locationId;
            alertAssigneeFieldValues[`alertAssigneeSubLocation_${key}`] = assignee && assignee.allSubLocation ? ALL_OPTION : subLocationId;
            alertAssigneeFieldValues[`alertAssigneeUser_${key}`] = userId;
          });
          this.props.form.setFieldsValue(alertAssigneeFieldValues);
          // console.log(id);
          this.getStatus(nextProps.data);
        }
      }
    }
    this.setState({
      eventStatus: nextProps.status
    })
  }

  getDocumentData = data => {
    this.setState({ documentData: data });
  };

  getSlackDocumentData = data => {
    this.setState({ slackDocumentData: data });
  };

  handleNotificationTypeChange = values => {
    this.setState({ notificationType: values });
  };

  handleSubmit = e => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const { documentData, slackDocumentData } = this.state;
      const data = Object.assign({}, values);
      const alertAssigneeKeys = values.alert_assignee_keys || [];
      const alertAssignees = (alertAssigneeKeys || []).map((k) => ({
        location: values[`alertAssigneeLocation_${k}`],
        subLocation: values[`alertAssigneeSubLocation_${k}`],
        user: values[`alertAssigneeUser_${k}`],
      })).filter((item) => item && item.location && item.user);

      if (alertAssignees.length > 0) {
        data.alertAssigneeLocation = alertAssignees.map((item) => item.location).join(",");
        data.alertAssigneeSubLocation = alertAssignees.map((item) => item.subLocation || "").join(",");
        data.alertAssigneeUser = alertAssignees.map((item) => item.user).join(",");
      }
      alertAssigneeKeys.forEach((k) => {
        delete data[`alertAssigneeLocation_${k}`];
        delete data[`alertAssigneeSubLocation_${k}`];
        delete data[`alertAssigneeUser_${k}`];
      });
      delete data.alert_assignee_keys;

      data.scheduleOptions = this.state.value;
      data.isActive = this.state.isActive;
      // console.log(data);

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  fetchFilters = values => {
    const selectedModule = values || "";
    this.setState({
      moduleName: selectedModule
    });
    this.props.form.setFieldsValue({ subModule: undefined });
    if (selectedModule) {
      this.props.fetchFilter(selectedModule);
    }
  };

  handleChangeEmailBody = (option, prefix) => {
    let emailBody = this.props.form.getFieldValue("body");
    let finalString = emailBody.replace(
      `@${option.value}`,
      `{${option.value}}`
    );
    this.props.form.setFieldsValue({ body: finalString });
  };

  handleChangeSlackParagraph = (option, prefix) => {
    let slackBody = this.props.form.getFieldValue("paragraph");
    let finalString = slackBody.replace(
      `@${option.value}`,
      `{${option.value}}`
    );
    this.props.form.setFieldsValue({ paragraph: finalString });
  };

  handleChangeSmsParagraph = (option, prefix) => {
    let smsBody = this.props.form.getFieldValue("smsParagraph");
    let finalString = smsBody.replace(`@${option.value}`, `{${option.value}}`);
    this.props.form.setFieldsValue({ smsParagraph: finalString });
  };

  handleCronChange = values => {
    this.setState({ value: values });
  };

  remove = k => {
    // console.log(k);
    id = +1;
    const { form } = this.props;
    const keys = form.getFieldValue("con_keys");
    if (keys.length === 1) {
      return;
    }
    form.setFieldsValue({
      con_keys: keys.filter(key => key !== k)
    });
  };

  add = () => {
    // id = id + 1;
    // console.log(id);
    const { form } = this.props;
    const keys = form.getFieldValue("con_keys");
    // const id = this.state.id;

    const nextKeys = keys.concat(id++);
    // console.log(keys, nextKeys);
    form.setFieldsValue({
      con_keys: nextKeys
    });
  };

  removeAlertAssignee = k => {
    const { form } = this.props;
    const keys = form.getFieldValue("alert_assignee_keys");
    if (keys.length === 1) {
      return;
    }
    form.setFieldsValue({
      alert_assignee_keys: keys.filter(key => key !== k)
    });
    this.revalidateAlertAssigneeScopes();
  };

  getAlertAssigneeScopes = () => {
    const { form } = this.props;
    const keys = form.getFieldValue("alert_assignee_keys") || [];
    return keys.map(key => ({
      key,
      rawLocation: form.getFieldValue(`alertAssigneeLocation_${key}`),
      location: toAssigneeScopeValue(form.getFieldValue(`alertAssigneeLocation_${key}`)),
      subLocation: toAssigneeScopeValue(form.getFieldValue(`alertAssigneeSubLocation_${key}`)),
    }));
  };

  // Returns the 1-based row number of the first other assignee row whose scope overlaps row `k`.
  findAlertAssigneeConflict = k => {
    const scopes = this.getAlertAssigneeScopes();
    const current = scopes.find(scope => scope.key === k);
    if (!current || !current.rawLocation) {
      return null;
    }
    const conflictIndex = scopes.findIndex(scope =>
      scope.key !== k && scope.rawLocation && assigneeScopesOverlap(current, scope)
    );
    return conflictIndex >= 0 ? conflictIndex + 1 : null;
  };

  hasAllScopeAlertAssignee = () =>
    this.getAlertAssigneeScopes().some(scope =>
      scope.rawLocation && scope.location === ALL_OPTION && scope.subLocation === ALL_OPTION
    );

  // Re-run the overlap check on every filled row once the changed value has been committed.
  revalidateAlertAssigneeScopes = () => {
    setTimeout(() => {
      const fields = this.getAlertAssigneeScopes()
        .filter(scope => scope.rawLocation)
        .map(scope => `alertAssigneeLocation_${scope.key}`);
      if (fields.length > 0) {
        this.props.form.validateFields(fields, { force: true });
      }
    }, 0);
  };

  addAlertAssignee = () => {
    const { form } = this.props;
    const keys = form.getFieldValue("alert_assignee_keys");
    const newKey = `ak_${alertAssigneeId++}`;
    const nextKeys = keys.concat(newKey);
    form.setFieldsValue({
      alert_assignee_keys: nextKeys,
      [`alertAssigneeLocation_${newKey}`]: undefined,
      [`alertAssigneeSubLocation_${newKey}`]: undefined,
      [`alertAssigneeUser_${newKey}`]: undefined,
    });
  };

  getSubLocationsByLocation = locationId => {
    const { subLocations } = this.state;
    const allSubLocations = subLocations || [];
    if (!locationId || locationId === ALL_OPTION) {
      return allSubLocations;
    }
    const filteredSubLocations = allSubLocations.filter((subLocation) => {
      const geoLocations = subLocation && subLocation.geoLocations ? subLocation.geoLocations : [];
      if (!geoLocations.length) {
        return false;
      }
      return geoLocations.some((geo) => {
        const mappedLocationId = geo && geo.location && geo.location._id ? geo.location._id : geo && geo.location;
        return mappedLocationId && mappedLocationId.toString() === locationId.toString();
      });
    });
    return filteredSubLocations.length > 0 ? filteredSubLocations : allSubLocations;
  };

  getIdFromRef = (ref) => {
    if (!ref) {
      return null;
    }
    if (ref._id) {
      return ref._id.toString();
    }
    return ref.toString();
  };

  isUserEligibleForAlertAssignee = (user, selectedLocation, selectedSubLocation) => {
    if (!user) {
      return false;
    }
    const userLocations = (user.locations || []).map(this.getIdFromRef).filter(Boolean);
    const userSubLocations = (user.clients || []).map(this.getIdFromRef).filter(Boolean);
    const hasAllLocationAccess = Boolean(user.allLocationAccess);
    const hasAllSubLocationAccess = Boolean(user.allClientAccess);

    if (selectedLocation === ALL_OPTION && !hasAllLocationAccess) {
      return false;
    }
    if (selectedLocation && selectedLocation !== ALL_OPTION && !hasAllLocationAccess && !userLocations.includes(selectedLocation.toString())) {
      return false;
    }

    if (selectedSubLocation === ALL_OPTION && !hasAllSubLocationAccess) {
      return false;
    }
    if (selectedSubLocation && selectedSubLocation !== ALL_OPTION && !hasAllSubLocationAccess && !userSubLocations.includes(selectedSubLocation.toString())) {
      return false;
    }

    return true;
  };

  filterSelectByLabel = (input, option) => {
    const label = option && option.props && option.props.children
      ? option.props.children.toString()
      : "";
    return label.toLowerCase().indexOf((input || "").toLowerCase()) >= 0;
  };

  onChangeActive = e => {
    this.setState({
      isActive: e.target.checked
    });
  };

  confirmToggleEventStatus = (isStart) => {
    const { _id, eventCode } = this.props.data;
    this.props.toggleStatus(_id, eventCode, isStart);
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      data,
      loading,
      filters,
      title,
      resource,
      subDocumentFilters,
      form
    } = this.props;
    // console.log(data['reminderOptions']);
    const conditionLength = data['reminderOptions'] ? data['reminderOptions'].length : 0;
    const initialConditionData = [...Array(conditionLength)].map((_, index) => index);
    // id = conditionLength;
    const { notificationType, value, eventType, locations } = this.state;
    const selectedModule = getFieldValue("module") || this.state.moduleName || (data && data.module) || "";
    const subModuleMap = filters &&
      filters["subModule"] &&
      filters["subModule"].options &&
      filters["subModule"].options.subModuleOptionsByModule
      ? filters["subModule"].options.subModuleOptionsByModule
      : {};
    const subModuleOptions = subModuleMap[selectedModule] || [];
    const columns =
      this.props &&
      this.props.moduleFilters &&
      Object.keys(this.props.moduleFilters).filter(filter =>
        Boolean(
          this.props.moduleFilters[filter].options &&
          this.props.moduleFilters[filter].type !== "Array" &&
          !this.props.moduleFilters[filter].options.notVisible ||
          (this.props.moduleFilters[filter].type !== "ObjectID" &&
            this.props.moduleFilters[filter].field !== "asset" &&
            this.state.moduleName.toString() === 'Complaint')
        )
      );

    getFieldDecorator("con_keys", { initialValue: initialConditionData });
    const keys = getFieldValue("con_keys");
    const initialAlertAssigneeData = getFieldValue("alert_assignee_keys") || this.getInitialAlertAssigneeKeys(data['alertAssignee']);
    getFieldDecorator("alert_assignee_keys", { initialValue: initialAlertAssigneeData });
    const alertAssigneeKeys = getFieldValue("alert_assignee_keys");
    const getRefId = (ref) => ref && ref._id ? ref._id : ref;
    // console.log(keys);
    const formConditionItems = keys.map((k, index) => (
      <Row type="flex" justify="center" key={k}>
        <Col span={4}>
          <Form.Item
            label={k === 0 ? "Condition" : null}
            required={eventType === "Reminder"}
            key={k}
          >
            {getFieldDecorator(`condition[${k}]`, {
              rules: [
                {
                  required: eventType === "Reminder",
                  message: "Please select logical condition",
                }],
              initialValue: data && data['reminderOptions'] && data['reminderOptions'][index] ?
                data['reminderOptions'][index]['fieldCondition'] : 'and'
            })(
              <Select
                // defaultActiveFirstOption={true}
                style={{ width: "60%", marginRight: 8 }}
              >
                <Select.Option key={"and"} value={"and"}>
                  AND
                </Select.Option>
                <Select.Option key={"or"} value={"or"}>
                  OR
                </Select.Option>
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={k === 0 ? "Field to compare" : null}
            required={eventType === "Reminder"}
            key={k}
          >
            {getFieldDecorator(`conditionField[${k}]`, {
              // validateTrigger: ['onChange', 'onBlur'],
              rules: [
                {
                  required: eventType === "Reminder",
                  message: "Please select field to compare."
                }
              ],
              initialValue: data && data['reminderOptions'] && data['reminderOptions'][index] ?
                data['reminderOptions'][index]['fieldName'] : ''

            })(
              <Select defaultActiveFirstOption={true} style={{ width: "100%" }}>
                {columns &&
                  columns.length &&
                  columns.map(item => (
                    <Select.Option key={item} value={item}>
                      {item}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            label={k === 0 ? "Condition metric" : null}
            required={eventType === "Reminder"}
            key={k}
          >
            {getFieldDecorator(`conditionMetric[${k}]`, {
              // validateTrigger: ['onChange', 'onBlur'],
              rules: [
                {
                  required: eventType === "Reminder",
                  message: "Please select condition metric."
                }
              ],
              initialValue: data && data['reminderOptions'] && data['reminderOptions'][index] ?
                data['reminderOptions'][index]['fieldCompare'] : ''
            })(
              <Select defaultActiveFirstOption={true} style={{ width: "50%" }}>
                <Select.Option key={"="} value={"="}>
                  {"="}
                </Select.Option>
                <Select.Option key={"!="} value={"!="}>
                  {"!="}
                </Select.Option>
                <Select.Option key={">"} value={">"}>
                  {">"}
                </Select.Option>
                <Select.Option key={">="} value={">="}>
                  {">="}
                </Select.Option>
                <Select.Option key={"<"} value={"<"}>
                  {"<"}
                </Select.Option>
                <Select.Option key={"<="} value={"<="}>
                  {"<="}
                </Select.Option>
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={k === 0 ?
              <span>Field value <Tooltip
                title={<div>
                  <p>Date format is DD/MM/YYYY for date type</p>
                  <p>If date value is number, it will represent past {'for < or <='} or future {'for > or >='} no. of
                    days from today</p>
                  <p>Text is case sensitive</p>
                </div>}><Icon type="info-circle" /></Tooltip></span> : null}
            required={eventType === "Reminder"}
            key={k}
          >
            {getFieldDecorator(`conditionFieldValue[${k}]`, {
              rules: [
                {
                  required: eventType === "Reminder",
                  message: "Please enter compared field value."
                }
              ],
              initialValue: data && data['reminderOptions'] && data['reminderOptions'][index] ?
                data['reminderOptions'][index]['fieldConditionValue'] : ''
            })(<Input style={{ width: "90%" }} />)}
            &nbsp;
            {keys.length > 1 && (keys.length - 1) === index ? (
              <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"
                onClick={() => this.remove(k)}
              />
            ) : null}
          </Form.Item>
        </Col>
      </Row>
    ));

    const alertAssigneeItems = alertAssigneeKeys.map((k, index) => {
      const selectedLocation = form.getFieldValue(`alertAssigneeLocation_${k}`) ||
        (data && data['alertAssignee'] && data['alertAssignee'][index]
          ? (data['alertAssignee'][index]['allLocation'] ? ALL_OPTION : getRefId(data['alertAssignee'][index]['location'])) : null);
      const selectedSubLocation = form.getFieldValue(`alertAssigneeSubLocation_${k}`) ||
        (data && data['alertAssignee'] && data['alertAssignee'][index]
          ? (data['alertAssignee'][index]['allSubLocation'] ? ALL_OPTION : getRefId(data['alertAssignee'][index]['subLocation'])) : null);
      const subLocationOptions = this.getSubLocationsByLocation(selectedLocation);
      return (
        <Row type="flex" justify="center" key={k}>
          <Col span={7}>
            <Form.Item
              label={k === 0 ? "Assignee Location" : null}
              required={notificationType && notificationType.includes("Alert")}
              key={`alert-location-${k}`}
            >
              {getFieldDecorator(`alertAssigneeLocation_${k}`, {
                rules: [
                  {
                    required: notificationType && notificationType.includes("Alert"),
                    message: "Please select assignee location."
                  },
                  {
                    validator: (rule, value, callback) => {
                      const conflictRow = value ? this.findAlertAssigneeConflict(k) : null;
                      if (conflictRow) {
                        callback(`Overlaps with assignee #${conflictRow} for this location/sub location.`);
                        return;
                      }
                      callback();
                    }
                  }
                ],
                initialValue: data && data['alertAssignee'] && data['alertAssignee'][index]
                  ? (data['alertAssignee'][index]['allLocation'] ? ALL_OPTION : getRefId(data['alertAssignee'][index]['location'])) : undefined
              })(
                <Select
                  showSearch={true}
                  allowClear={true}
                  style={{ width: "95%" }}
                  placeholder="Select location"
                  optionFilterProp="children"
                  filterOption={this.filterSelectByLabel}
                  onChange={this.revalidateAlertAssigneeScopes}
                >
                  <Select.Option key={ALL_OPTION} value={ALL_OPTION}>
                    All
                  </Select.Option>
                  {(locations || []).map((location) => (
                    <Select.Option key={location._id} value={location._id}>
                      {location.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label={k === 0 ? "Assignee Sub Location (Optional)" : null}
              key={`alert-sublocation-${k}`}
            >
              {getFieldDecorator(`alertAssigneeSubLocation_${k}`, {
                initialValue: data && data['alertAssignee'] && data['alertAssignee'][index]
                  ? (data['alertAssignee'][index]['allSubLocation'] ? ALL_OPTION : getRefId(data['alertAssignee'][index]['subLocation'])) : undefined
              })(
                <Select
                  showSearch={true}
                  allowClear={true}
                  style={{ width: "95%" }}
                  placeholder="Select sub location"
                  optionFilterProp="children"
                  filterOption={this.filterSelectByLabel}
                  onChange={this.revalidateAlertAssigneeScopes}
                >
                  <Select.Option key={ALL_OPTION} value={ALL_OPTION}>
                    All
                  </Select.Option>
                  {(subLocationOptions || []).map((subLocation) => (
                    <Select.Option key={subLocation._id} value={subLocation._id}>
                      {subLocation.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={k === 0 ? "Assignee User" : null}
              required={notificationType && notificationType.includes("Alert")}
              key={`alert-user-${k}`}
            >
              {getFieldDecorator(`alertAssigneeUser_${k}`, {
                rules: [
                  {
                    required: notificationType && notificationType.includes("Alert"),
                    message: "Please select assignee user."
                  },
                  {
                    validator: (rule, value, callback) => {
                      if (!value) {
                        callback();
                        return;
                      }
                      const users = (filters["users"] && filters["users"].data && filters["users"].data.data) || [];
                      const selectedUser = users.find((item) => item && item._id && item._id.toString() === value.toString());
                      const isEligible = this.isUserEligibleForAlertAssignee(
                        selectedUser,
                        form.getFieldValue(`alertAssigneeLocation_${k}`) || selectedLocation,
                        form.getFieldValue(`alertAssigneeSubLocation_${k}`) || selectedSubLocation
                      );
                      if (!isEligible) {
                        callback("Selected user does not have access for chosen location/sub location.");
                        return;
                      }
                      callback();
                    }
                  },
                ],
                initialValue: data && data['alertAssignee'] && data['alertAssignee'][index]
                  ? getRefId(data['alertAssignee'][index]['user']) : undefined
              })(
                <Select
                  showSearch={true}
                  allowClear={true}
                  style={{ width: "90%" }}
                  placeholder="Select user"
                  optionFilterProp="children"
                  filterOption={this.filterSelectByLabel}
                >
                  {filters["users"] &&
                    filters["users"].data &&
                    filters["users"].data.data &&
                    filters["users"].data.data.map((item) => {
                      if (this.isUserEligibleForAlertAssignee(item, selectedLocation, selectedSubLocation)) {
                        return (
                          <Select.Option key={item._id} value={item._id}>
                            {item.name}
                          </Select.Option>
                        );
                      }
                      return null;
                    })}
                </Select>
              )}
              &nbsp;
              {alertAssigneeKeys.length > 1 && (alertAssigneeKeys.length - 1) === index ? (
                <Icon
                  className="dynamic-delete-button"
                  type="minus-circle-o"
                  onClick={() => this.removeAlertAssignee(k)}
                />
              ) : null}
            </Form.Item>
          </Col>
        </Row>
      );
    });

    return (
      <Spin spinning={loading}>
        <Card
          className={`gx-card-metrics`}
          title={`${title} ${sanitizeFieldName(resource)}`}
        >
          <div>
            {
              (eventType && (eventType === "Schedule" || eventType === "Reminder")) ?
                this.state.eventStatus ? (
                  <Popconfirm
                    title="Are you sure stop this schedule?"
                    onConfirm={() => this.confirmToggleEventStatus(false)}
                    // onCancel={this.cancelToggleEventStatus}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      loading={this.props.loadingStatus}
                      type="primary"
                      size={"small"}
                      style={{ float: 'right' }}
                    >
                      <Icon type="sync" spin /> Running
                    </Button>
                  </Popconfirm>) : (
                  <Popconfirm
                    title="Are you sure start this schedule?"
                    onConfirm={() => this.confirmToggleEventStatus(true)}
                    // onCancel={this.cancelToggleEventStatus}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      loading={this.props.loadingStatus}
                      type="danger"
                      size={"small"}
                      style={{ float: 'right' }}
                    >
                      <Icon type="pause" /> Stopped
                    </Button>
                  </Popconfirm>) : null
            }
          </div>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            {Object.keys(filters).map(item => {
              if (item === "subModule") {
                return null;
              }
              if (
                filters[item].type === "Boolean" &&
                filters[item].options &&
                !filters[item].options.hidden
              ) {
                return (
                  <Form.Item key={item} label={"Is Active"}>
                    {getFieldDecorator(item, {
                      // initialValue: data && data[item]
                    })(
                      <Checkbox
                        onChange={this.onChangeActive}
                        checked={this.state.isActive}
                      />
                    )}
                  </Form.Item>
                );
              }

              if (
                filters[item].type === "String" &&
                filters[item].options &&
                !filters[item].options.hidden &&
                item === "subModule"
              ) {
                if (!subModuleOptions.length) {
                  return null;
                }
                return (
                  <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      initialValue: data && data[item] ? data[item] : undefined
                    })(
                      <Select
                        mode="single"
                        showSearch
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Please select"
                        filterOption={(input, option) =>
                          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                      >
                        {subModuleOptions.map((subModule) => (
                          <Select.Option key={subModule} value={subModule}>
                            {sanitizeFieldName(subModule)}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                );
              }

              if (
                filters[item].type === "String" &&
                filters[item].options &&
                !filters[item].options.hidden &&
                !filters[item].options.hiddenOnCreate &&
                !filters[item].options.enum &&
                item !== "subModule"
              ) {
                return (
                  <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [
                        { required: true, message: `${item} is required!` }
                      ],
                      initialValue:
                        item !== "password" ? data && data[item] : ""
                    })(<Input />)}
                  </Form.Item>
                );
              }

              if (
                this.props.title === "EDIT" &&
                filters[item].options.hiddenOnCreate
              ) {
                return (
                  <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [
                        { required: true, message: `${item} is required!` }
                      ],
                      initialValue:
                        item !== "password" ? data && data[item] : ""
                    })(<Input disabled={true} />)}
                  </Form.Item>
                );
              }

              if (
                filters[item].type === "String" &&
                filters[item].options &&
                !filters[item].options.hidden &&
                filters[item].options.enum &&
                item !== "module"
              ) {
                return (
                  <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [
                        { required: true, message: `${item} is required!` }
                      ],
                      initialValue:
                        item !== "password" ? data && data[item] : ""
                    })(
                      <Select
                        mode="single"
                        showSearch={true}
                        allowClear={true}
                        style={{ width: "100%" }}
                        placeholder="Please select"
                        onSelect={e => {
                          this.setState({ eventType: e });
                        }}
                      >
                        {filters[item] &&
                          filters[item].options &&
                          filters[item].options.enum &&
                          filters[item].options.enum.map(item => (
                            <Select.Option key={item} value={item}>
                              {sanitizeFieldName(item)}
                            </Select.Option>
                          ))}
                      </Select>
                    )}
                  </Form.Item>
                );
              }

              if (
                filters[item].type === "String" &&
                filters[item].options &&
                !filters[item].options.hidden &&
                item === "module"
              ) {
                return (
                  <React.Fragment key={`${item}-wrapper`}>
                    <Form.Item key={item} label={sanitizeFieldName(item)}>
                      {getFieldDecorator(item, {
                        rules: [
                          { required: true, message: `${item} is required!` }
                        ],
                        initialValue:
                          item !== "password" ? data && data[item] : ""
                      })(
                        <Select
                          mode="single"
                          showSearch
                          allowClear
                          style={{ width: "100%" }}
                          onChange={this.fetchFilters}
                          placeholder="Please select"
                          filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                          }
                        >
                          {filters[item] &&
                            filters[item].options &&
                            filters[item].options.enum &&
                            filters[item].options.enum.map(item => (
                              <Select.Option key={item} value={item}>
                                {item === 'AssetClassification' ? 'Asset Category' : sanitizeFieldName(item)}
                              </Select.Option>
                            ))}
                        </Select>
                      )}
                    </Form.Item>
                    {subModuleOptions.length > 0 ? (
                      <Form.Item key={"subModule_inline"} label={"Sub Module"}>
                        {getFieldDecorator("subModule", {
                          initialValue: data && data["subModule"] ? data["subModule"] : undefined
                        })(
                          <Select
                            mode="single"
                            showSearch
                            allowClear
                            style={{ width: "100%" }}
                            placeholder="Please select"
                            filterOption={(input, option) =>
                              (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                            }
                          >
                            {subModuleOptions.map((subModule) => (
                              <Select.Option key={subModule} value={subModule}>
                                {sanitizeFieldName(subModule)}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    ) : null}
                  </React.Fragment>
                );
              }

              if (filters[item].type === "Array" && item === "users") {
                return (
                  <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [
                        {
                          required: true,
                          message: `${sanitizeFieldName(item)} is required!`
                        }
                      ],
                      initialValue:
                        data && data[item]
                          ? data[item].map(field => field._id)
                          : []
                    })(
                      <Select
                        showSearch={true}
                        mode="multiple"
                        style={{ width: "100%" }}
                        placeholder="Please select"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {filters[item] &&
                          filters[item].data &&
                          filters[item].data.data &&
                          filters[item].data.data.map(item => {
                            const disabledRoles = item.roles.filter(role => role.disableNotification);
                            if (disabledRoles.length === 0) {
                              return (
                                <Select.Option key={item._id} value={item._id}>
                                  {item.name}
                                </Select.Option>
                              )
                            }
                          })}
                      </Select>
                    )}
                  </Form.Item>
                );
              }

              if (
                filters[item].type === "Array" &&
                filters[item].options.enum &&
                item === "notificationType"
              ) {
                return (
                  <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [
                        {
                          required: true,
                          message: `${sanitizeFieldName(item)} is required!`
                        }
                      ],
                      initialValue: data && data[item] ? data[item] : []
                    })(
                      <Select
                        mode="multiple"
                        style={{ width: "100%" }}
                        placeholder="Please select"
                        onChange={this.handleNotificationTypeChange}
                      >
                        {filters[item] &&
                          filters[item].options &&
                          filters[item].options.enum &&
                          filters[item].options.enum.map(item => (
                            <Select.Option key={item} value={item}>
                              {item}
                            </Select.Option>
                          ))}
                      </Select>
                    )}
                  </Form.Item>
                );
              }
              return null;
            })}
            {eventType && eventType !== "Alert" && notificationType && notificationType.includes("Email") ? (
              <div>
                <div>Email Template</div>
                <div
                  style={{
                    marginTop: "10px",
                    border: "1px dashed #000",
                    padding: "20px",
                    borderRadius: "9px"
                  }}
                >
                  <Form.Item key={"subject"}>
                    {getFieldDecorator("subject", {
                      rules: [
                        {
                          required: true,
                          message: `Email subject is required!`
                        }
                      ],
                      initialValue:
                        data &&
                        data["emailTemplate"] &&
                        data["emailTemplate"]["subject"]
                    })(<Input placeholder={"Subject"} />)}
                  </Form.Item>

                  <Form.Item
                    key={"body"}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                  >
                    {getFieldDecorator("body", {
                      rules: [
                        { required: true, message: `Email body is required!` }
                      ],
                      initialValue:
                        data &&
                        data["emailTemplate"] &&
                        data["emailTemplate"]["body"]
                    })(
                      <Mentions
                        rows="4"
                        onSelect={this.handleChangeEmailBody}
                        placeholder="Body text, You can use @ to ref schema fields here for the selected module"
                      >
                        {columns &&
                          columns.length &&
                          columns.map(item => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                      </Mentions>
                    )}
                  </Form.Item>
                </div>
              </div>
            ) : (
              <> </>
            )}

            {eventType && eventType !== "Alert" && notificationType && notificationType.includes("Slack") ? (
              <div>
                <div>Slack Template</div>
                <div
                  style={{
                    marginTop: "10px",
                    border: "1px dashed #000",
                    padding: "20px",
                    borderRadius: "9px"
                  }}
                >
                  <Form.Item key={"title"}>
                    {getFieldDecorator("title", {
                      rules: [
                        {
                          required: true,
                          message: `Slack message title is required!`
                        }
                      ],
                      initialValue:
                        data &&
                        data["slackTemplate"] &&
                        data["slackTemplate"]["title"]
                    })(<Input placeholder={"Message Title"} />)}
                  </Form.Item>

                  <Form.Item
                    key={"body"}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                  >
                    {getFieldDecorator("paragraph", {
                      rules: [
                        { required: true, message: `Slack message is required!` }
                      ],
                      initialValue:
                        data &&
                        data["slackTemplate"] &&
                        data["slackTemplate"]["paragraph"]
                    })(
                      <Mentions
                        rows="4"
                        onSelect={this.handleChangeSlackParagraph}
                        placeholder="Message text, You can use @ to ref schema fields here for the selected module"
                      >
                        {columns &&
                          columns.length &&
                          columns.map(item => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                      </Mentions>
                    )}
                  </Form.Item>
                </div>
              </div>
            ) : (
              <> </>
            )}

            {eventType && eventType !== "Alert" && notificationType && notificationType.includes("SMS") ? (
              <div>
                <div style={{ marginTop: "12px" }}>SMS Template</div>
                <div
                  style={{
                    marginTop: "10px",
                    border: "1px dashed #000",
                    padding: "20px",
                    borderRadius: "9px"
                  }}
                >
                  <Form.Item
                    key={"smsParagraph"}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                  >
                    {getFieldDecorator("smsParagraph", {
                      initialValue:
                        data &&
                        data["smsTemplate"] &&
                        data["smsTemplate"]["paragraph"]
                    })(
                      <Mentions
                        rows="4"
                        onSelect={this.handleChangeSmsParagraph}
                        placeholder="Body text, You can use @ to ref schema fields here for the selected module"
                      >
                        {columns &&
                          columns.length &&
                          columns.map(item => (
                            <Option value={item}>{item}</Option>
                          ))}
                      </Mentions>
                    )}
                  </Form.Item>
                </div>
              </div>
            ) : (
              <> </>
            )}

            {eventType &&
              (eventType === "Schedule" || eventType === "Reminder") && (
                <div>
                  <div style={{ marginTop: "20px", marginBottom: "5px" }}>
                    Schedule Options
                  </div>
                  <div style={{ marginTop: "12px" }}>
                    {/*<Form.Item key={'jobName'} label={'Job Name'}>*/}
                    {/*{getFieldDecorator('jobName', {*/}
                    {/*rules: [{required: true, message: `Job Name is required!`}],*/}
                    {/*initialValue: data && data['cronData'] && data['cronData']['fileName'],*/}
                    {/*})(<Input placeholder={'Please Enter Schedule Job Name'}/>)}*/}
                    {/*</Form.Item>*/}

                    <Cron
                      onChange={this.handleCronChange}
                      value={value}
                      showResultText={true}
                      showResultCron={true}
                    />
                  </div>
                </div>
              )}

            {eventType && eventType === "Reminder" && (
              <div>
                <div style={{ marginTop: "20px", marginBottom: "5px" }}>
                  Module Conditions
                </div>
                <div style={{ marginTop: "12px" }}>
                  {formConditionItems}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={this.add}
                      style={{ width: "60%" }}
                    >
                      <Icon type="plus" /> Add field
                    </Button>
                  </Form.Item>
                </div>
              </div>
            )}

            {notificationType && notificationType.includes("Alert") && (
              <div>
                <Form.Item
                  label="Automatic Escalation Time (hours)"
                  style={{ marginTop: "20px" }}
                >
                  {getFieldDecorator("automaticEscalationTime", {
                    rules: [
                      {
                        required: notificationType && notificationType.includes("Alert"),
                        message: "Automatic Escalation Time is required",
                      },
                    ],
                    initialValue:
                      data && data.automaticEscalationTime !== undefined && data.automaticEscalationTime !== null
                        ? data.automaticEscalationTime
                        : undefined,
                  })(
                    <InputNumber
                      min={1}
                      style={{ width: "100%" }}
                      placeholder="Enter escalation time in hours"
                    />
                  )}
                </Form.Item>
                <div style={{ marginTop: "20px", marginBottom: "5px" }}>
                  Alert Assignee
                </div>
                <div style={{ marginTop: "12px" }}>
                  {alertAssigneeItems}
                  <Form.Item
                    help={this.hasAllScopeAlertAssignee()
                      ? "An assignee already covers all locations and sub locations."
                      : null}
                  >
                    <Button
                      type="dashed"
                      onClick={this.addAlertAssignee}
                      disabled={this.hasAllScopeAlertAssignee()}
                      style={{ width: "60%" }}
                    >
                      <Icon type="plus" /> Add assignee
                    </Button>
                  </Form.Item>
                </div>
              </div>
            )}

            <Form.Item>
              <Button
                type="primary"
                className="gx-mb-0"
                htmlType="submit"
                loading={loading}
              >
                {this.props.title === "EDIT" ? "UPDATE" : "CREATE"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: "global_state",
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  }
})(Create);

export default CreateForm;
